import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      navHome: "Home",
      navAbout: "About",
      navServices: "Services",
      navOffers: "Pricing",
      navContact: "Contact",
      welcome: "NCTS T1 Transit Document Preparation in Georgia",
      desc: "We help logistics companies and transport operators quickly process T1 transit declarations across Georgia with full customs support.",
      aboutTitle: "About GeoGlobalGate LTD",
      aboutText: "GeoGlobalGate LTD is a company licensed by the Ministry of Finance of Georgia, Revenue Service, providing NCTS T1 document preparation in Georgia. Our goal is to simplify customs procedures and help companies optimize their time and resources.",
      aboutWhyTitle: "Why do companies choose GeoGlobalGate LTD as their partner?",
      aboutWhyText: "Working with us means reliability, professionalism, and a results-oriented approach. We offer tailored solutions to each client and ensure the process is managed efficiently and transparently. Our goal is not just to provide a service — we build long-term partnerships that genuinely support business growth and development. Our team is ready 24/7 to help you prepare NCTS T1 documents in the shortest possible time. We provide services remotely and electronically, ensuring a fast, simple, and effective process.",
      aboutServicesTitle: "Our services include:",
      aboutServiceItem1: "Preparation of NCTS T1 transit declarations.",
      aboutServiceItem2: "Full administration of customs documentation.",
      aboutServiceItem3: "Coordination with customs authorities and operational support.",
      aboutRepresentativeText: "We act as your trusted representative at the customs terminal and ensure all procedures are carried out correctly and on time.",
      aboutBestChoiceTitle: "Why is GeoGlobalGate LTD your best choice?",
      aboutBestItem1: "Licensed NCTS Operator in Georgia",
      aboutBestItem2: "24/7 Availability – No Delays",
      aboutBestItem3: "Remote Service – No Physical Presence Needed",
      aboutBestItem4: "Experience with Complex Transit Cases",
      aboutCtaText: "Contact us today and receive reliable customs services in Georgia.",
      servicesNavLabel: "Services",
      servicesTitle: "Our Services",
      servicesSubtitle: "Comprehensive customs and transit solutions for your business.",
      svc1Title: "NCTS T1 Declaration Services in Georgia",
      svc1Item1: "Fast T1 document preparation",
      svc1Item2: "Electronic processing",
      svc1Item3: "Remote support 24/7",
      svc2Title: "Customs Brokerage",
      svc2Item1: "Full declaration handling",
      svc2Item2: "T1/T2 documentation",
      svc2Item3: "Risk reduction",
      svc3Title: "Transit Support",
      svc3Item1: "Coordination with customs authorities",
      svc3Item2: "Real-time assistance at borders",
      svc3Item3: "Problem resolution",
      svc4Title: "Communication Support",
      svc4Desc: "Our hotline is available 24/7, providing multilingual support in Georgian, Turkish, Azerbaijani, Russian, English, Ukrainian, and Spanish, ensuring clear and efficient communication at all times.",
      service1: "Customs procedures",
      service2: "Expertise",
      service3: "Obtaining a Phytosanitary Certificate",
      service4: "Obtaining a Origin Certificate",
      service5: "Taking other customs documents",
      offersTitle: "Customs Brokerage Price",
      offerSubtitle: "NCTS T1 Service Prices",
      column1: "Name",
      column2: "Customs Corridor",
      column3: "Price",
      table1: "Brokerage Service",
      table2: "Declaration",
      table3: "Additional code",
      table4: "Complex declaration (more than 15 commodity codes)",
      table5: "Phytosanitary certificate",
      table6: "Origin certificate",
      table7: "Transit declaration (T1)",
      green: "Green",
      red: "Red",
      yellow: "Yellow",
      any: "Any of them",
      warning: "* Prices are determined per one customs declaration, the price does not include customs fees and other government taxes.",
      input1: "Company Name",
      input2: "Your Name",
      input3: "Your Email",
      phoneNumber: "Your Phone Number",
      vehicleNumber: "Vehicle Number",
       shipmentPrice: "Cargo value",
      serviceTypeLabel: "What service do you need?",
      selectService: "Select a service",
      transit: "Transit",
      export: "Export",
      evaluationCustomsOffice: "Evaluation customs office in Georgia",
      exitCustomsOfficeExport: "Exit customs office from Georgia",
      entryCustomsOffice: "Entry customs office to Georgia",
      exitCustomsOfficeTransit: "Exit customs office from Georgia",
      route: "Route",
      routeInfoTitle: "Route Entry Instructions",
      routeInfoContent: "Please enter the specific names/codes of transit customs offices in the route",
      routeInfoButton: "Understood",
      finalClearanceLocation: "Final clearance location",
      requiredDocuments: "Required Documents",
      selectFile: "Select File",
      selectFiles: "Select Files",
      attachFiles: "Attach Files",
      cmr: "CMR",
      declaration: "transit declaration",
      invoice: "Invoice",
      packingList: "Packing list",
      vehicleRegistration: "Vehicle registration details",
      driverPassport: "Driver's passport",
      registrationCertificate: "Registration certificate or D-number declaration",
      input7: "Your Message",
      send: "Send Message",
      contactTitle: "Tell us what you need",
      status: "Request sent successfully, we will contact you soon",
      error: "Failed to send the message. Please try again.",
      pleaseUpload: "Please upload",
      selectOption: "Please select",
      paymentAmount: "Payment Amount",
      carNumber: "Car Number",
      payButton: "Pay",
      negotiable: "individual",
      companyNameRequired: "Company name is required",
      nameRequired: "Name is required",
      emailRequired: "Email is required",
      phoneRequired: "Phone number is required",
      carNumberRequired: "Vehicle number is required",
      serviceRequired: "Service type is required",
      invalidEmail: "Invalid email format",
      evaluationCustomsRequired: "Evaluation customs office is required",
      exitCustomsExportRequired: "Exit customs office (Export) is required",
      entryCustomsRequired: "Entry customs office is required",
      exitCustomsTransitRequired: "Exit customs office (Transit) is required",
      routeRequired: "Route is required",
      clearanceLocationRequired: "Final clearance location is required",
      filesRequired: "Files are required",
      selectCurrency: "Select Currency",
      uploaded: "Uploaded",
      uploadedFiles: "Uploaded Files",
      removeAll: "Remove All",
      removeFile: "Remove File",
      files: "files",
      fileTooBig: "File too big",
      totalSizeExceeded: "Total size exceeded",
      filesAddedSuccess: "file(s) added successfully",
      allFilesRemoved: "All files removed",
      acceptTerms: "I accept the",
      termsAndConditions: "Terms & Conditions",
      termsRequired: "You must accept the terms and conditions",
      termsTitle: "Terms & Conditions",
      termsContent: `GeoGlobalGate – Terms & Conditions

I. General Provisions
The company GeoGlobalGate provides customs and transit services in accordance with applicable law.
By accepting these Terms & Conditions, the Client enters into a legally binding agreement.

II. Full Description of Services
The Company provides the following services:
• Consulting on cargo specifics, routes, and customs requirements;
• Preparation of full customs documentation: invoice, packing list, transport documents (CMR / Bill of Lading / Airway Bill), certificate of origin, import-export permits, and customs declarations;
• Monitoring compliance with customs regulations and liaising with customs authorities;
• Calculation of taxes and duties;
• Risk management and consulting on trade and customs payments;
• Managing transit procedures, MRN monitoring, and closure at destination customs.

III. Full Service Conditions
• The Client must provide complete and accurate documentation. The Company is not liable for delays or fines caused by incorrect or incomplete data.
• Services commence only after receipt of full documentation and payment confirmation.
• The Company reserves the right to refuse service if the Client fails to meet requirements or provide necessary information.

IV. Service Timelines
• Preparation of the T1 declaration is completed within 1 hour after receipt of full documentation and payment confirmation.
• Timelines for other services are determined individually and communicated to the Client in advance.

V. Cancellation & Refund Policy
Cancellation:
• Cancellation of a T1 declaration is only possible before customs procedures begin.
• If the cargo is already "released," cancellation is not possible.
• A cancellation fee of 100 GEL applies.

Refunds:
• Refunds will be made only to the same account or card used for payment.
• Refunds will be processed within a maximum of 14 calendar days from the date of the request.
• Any administrative costs will be communicated to the Client in advance.

VI. Dispute Resolution Policy
• All complaints and disputes must be submitted via email: support@geoglobalgate.com.
• The Company shall review and respond to the Client's claim within 10 business days.
• If no agreement is reached, disputes will be resolved under Georgian law by the competent courts of Georgia.

VII. Data Protection
Client personal data is processed solely for service provision and in compliance with applicable law.`,
      successModalTitle: "Application Received",
      successModalCompany: "Company \"GeoGlobalGate\" has received your application.",
      successModalMessage: "Our manager will contact you shortly.",
      successModalClose: "Close",
      navFaq: "FAQ",
      faqTitle: "Frequently Asked Questions (FAQ)",
      faq1Q: "Who provides NCTS T1 services in Georgia?",
      faq1A: "GeoGlobalGate LTD is a licensed NCTS operator in Georgia, offering full services for transit T1 declarations, customs processes, and international cargo management.",
      faq2Q: "Who are your services designed for?",
      faq2A: "GeoGlobalGate LTD works with small and medium-sized businesses as well as large companies looking for a reliable and efficient partner.",
      faq3Q: "How does the cooperation begin?",
      faq3A: "Cooperation begins with a detailed analysis of your needs, after which we offer a specific, tailored solution.",
      faq3Step1: "Send us shipment details",
      faq3Step2: "We prepare your T1 declaration",
      faq3Step3: "You receive documents instantly",
      faq3Step4: "Truck moves without delay",
      faq4Q: "How quickly is the service delivered?",
      faq4A: "Our team ensures the fastest and most efficient execution of processes while maintaining high quality standards. We prepare NCTS T1 documents within 10–20 minutes of receiving complete documentation.",
      faq5Q: "How can I contact you?",
      faq5A: "You can reach us via the contact numbers listed on the website, as well as by email. You can also submit an application electronically through our portal, ensuring fast and easy communication.",
      // NCTS Section
      nctsTitle: "NCTS Transit System",
      nctsIntro: "NCTS is a unified digital customs system that simplifies and accelerates transit procedures in Europe and partner countries, including Georgia.",
      nctsWhat: "What is NCTS?",
      nctsDescription: "The abbreviation NCTS refers to the New Computerised Transit System established under the Common Transit Convention (CTC). It enables goods to move under a single transit declaration in the following ways:",
      nctsMovement1: "From a CTC member country to another CTC member country",
      nctsMovement2: "From a third country to a CTC member country",
      nctsMovement3: "From a CTC member country via a third country to another CTC member country",
      nctsMovement4: "From a CTC member country to a third country",
      ctcCountriesTitle: "CTC Member Countries",
      ctcCountriesIntro: "The CTC (Common Transit Convention) includes:",
      ctcCountryEU: "All EU Member States (Belgium, Bulgaria, Czech Republic, Denmark, Germany, Estonia, Ireland, Greece, Spain, France, etc.)",
      ctcCountrySwitzerland: "Switzerland",
      ctcCountryNorway: "Norway",
      t1BenefitsTitle: "T1 benefits",
      ctcCountryIceland: "Iceland",
      ctcCountryMacedonia: "North Macedonia",
      ctcCountrySerbia: "Serbia",
      ctcCountryTurkey: "Turkey",
      ctcCountryUK: "United Kingdom",
      ctcCountryGeorgia: "Georgia",
      nctsImportanceTitle: "Why is NCTS important?",
      nctsSimplification: "Simplification of customs processes",
      nctsSimplificationDesc: "Documentation is automated, and customs authorities monitor the transit in real time, reducing formalities and preventing delays.",
      nctsControl: "Improved control",
      nctsControlDesc: "Cargo routes are fully monitored, and any deviations or disruptions are immediately registered in the system.",
      nctsSpeed: "Speed and transparency",
      nctsSpeedDesc: "Transit procedures are faster and less bureaucratic, reducing the risk of loss or illegal shipments.",
      nctsEfficiency: "International efficiency",
      nctsEfficiencyDesc: "Beyond the EU, the system includes partner countries, significantly improving cross-border cooperation.",
      t1FormTitle: "The importance of the T1 form",
      t1FormDesc: "The T1 form is the primary document for international transit, providing both legal and operational guarantees:",
      t1Benefit1: "Legally secures the goods by officially registering them in the customs system",
      t1Benefit2: "Waives advance payment of import duties until the goods reach their final customs destination",
      t1Benefit3: "Simplifies movement and reduces time and resources spent on customs procedures",
      t1Benefit4: "Protects logistics processes from unnecessary delays, as customs authorities recognize the cargo as controlled",
      t1PreparationTitle: "How is the T1 form prepared?",
      t1PreparationDesc: "A correctly completed T1 requires:",
      t1Requirement1: "Accurate and detailed cargo information",
      t1Requirement2: "Full details of consignor and consignee",
      t1Requirement3: "Route information and border-crossing details",
      t1Requirement4: "Access to specialized customs systems (such as NCTS)",
      t1Recommendation: "For this reason, it is recommended to entrust T1 preparation to a professional customs agent or logistics specialist.",
      nctsConclusion: "Conclusion",
      nctsConclusionText: "NCTS is no longer an option — it is a necessity. Its implementation ensures faster, safer, and more predictable transit. For companies offering international shipments, integration into the system is a key condition for successful operation in the global market.",
      heroCta: "Get Your NCTS T1 Declaration Prepared in Minutes!",
      aboutBestItem5: "Experience with Complex Transit Cases",
      aboutGuarantee: "GeoGlobalGate LTD, as an authorized transit operator, ensures complete guarantee coverage for all shipments. Guarantee registration and accounting are carried out in full compliance via the NCTS Transit System.",
      howWeWorkTitle: "How We Work",
      howWeWorkSubtitle: "Simple and transparent customs clearance process",
      howWeWorkStep1Title: "Request",
      howWeWorkStep1Desc: "You send us your documents and cargo details via email or our contact form. Our manager contacts you to confirm the details.",
      howWeWorkStep2Title: "Analysis",
      howWeWorkStep2Desc: "We review your documentation, determine the correct transit procedure, and calculate customs clearance requirements.",
      howWeWorkStep3Title: "Processing",
      howWeWorkStep3Desc: "We prepare and submit the NCTS T1 declaration within 10–20 minutes of receiving all documents.",
      howWeWorkStep4Title: "Release",
      howWeWorkStep4Desc: "Your cargo is cleared and released. We monitor the MRN until full closure at the destination customs.",
      whoWeWorkWithTitle: "Who We Work With",
      whoWeWorkWithSubtitle: "We serve a wide range of clients across the logistics and trade industry.",
      clientType1: "Transport Companies",
      clientType2: "Freight Forwarders",
      clientType3: "Exporters & Importers",
      clientType4: "Logistics Operators",
      clientType5: "Customs Brokers",
      whereWeOperateTitle: "Where We Operate",
      whereWeOperateIntro: "We operate across Georgia, covering all major border crossings and customs points to ensure smooth and efficient transit operations. Our services extend beyond borders, supporting shipments to and from the EU, Turkey, Azerbaijan, Armenia, Russia, Kazakhstan, China, Ukraine and more. Wherever your cargo moves, we provide reliable guidance and end-to-end coordination.",
      whereWeOperateGeorgia: "Georgia — All Active Border Crossings",
      whereWeOperateCountries: "EU Countries, Turkey, Azerbaijan, Armenia, Russia, Kazakhstan, China, Ukraine and more",
      whereWeOperateBorders: "Sarpi, Vale, Larsi, Red Bridge, Kartsakhi, Lagodekhi, etc.",
      coverageLabel: "Coverage",
      coverageItem1: "Georgia",
      coverageItem2: "Borders: Sarpi, Vale, Larsi, Red Bridge, Kartsakhi, Lagodekhi, etc.",
      coverageItem3: "Transit to/from EU, Turkey, Azerbaijan, Armenia, Russia, Kazakhstan, China…",
      statsTitle: "GeoGlobalGate — By the Numbers",
      statDeclarationsValue: "43,389+",
      statDeclarations: "T1/T2 Declarations Processed",
      statCountriesValue: "37",
      statCountries: "Countries Covered",
      statClientsValue: "1,570+",
      statClients: "Satisfied Clients",
      statSpeedValue: "10–20 min",
      statSpeed: "Average Processing Time",
      faq6Q: "What documents are required?",
      faq6A: "To prepare a T1 declaration, we typically need:",
      faq6Step1: "Commercial invoice",
      faq6Step2: "Packing list",
      faq6Step3: "Transport document (CMR)",
      faq6Step4: "Vehicle and driver details",
      faq6Step5: "Route information",
      faq6Closing: "Our team will guide you if any additional details are required.",
      faq7Q: "Do you work 24/7?",
      faq7A: "Yes, we operate at late hours as well to support your shipments at any time.",
      faq7A2: "We understand that logistics never stops, so our team is always ready to assist—even at night, weekends, and holidays.",
      careerBadge: "We Are Hiring",
      careerTitle: "Build Your Career with GeoGlobalGate",
      careerP1: "At GeoGlobalGate, we support businesses in navigating complex customs and transit processes across international markets.",
      careerP2: "We are growing — and we are always looking for motivated professionals who want to grow with us.",
      careerP3: "If you have experience in customs, logistics, or international trade and are ready for a new challenge, we would be glad to hear from you.",
      careerP4: "We offer a dynamic and supportive environment, with opportunities to develop your expertise and work on real cross-border operations.",
      careerP5: "looking to enter the field — GeoGlobalGate can be the next step in your career.",
      careerCta: "📩 Contact us to explore current or future opportunities. Send us your CV to:",
      customerServiceSubtitle: "Answers to your questions",
      customerServiceP1: "We help you reach the right support quickly and efficiently.",
      customerServiceP2: "Whether your request is related to transit, customs procedures, or shipment coordination, our team ensures it is directed to the appropriate specialist.",
      customerServiceTagline: "Clear communication. Faster resolution.",
      footerFollowUs: "Follow Us",
      footerRights: "© 2026 GeoGlobalGate LTD — All Rights Reserved",
      navHowWeWork: "How We Work",
      navCareer: "Career",
      navStats: "Numbers"
    },
  },
  ge: {
    translation: {
      navHome: "მთავარი",
      navAbout: "ჩვენს შესახებ",
      navServices: "სერვისები",
      navOffers: "ტარიფები",
      navContact: "კონტაქტი",
      welcome: "NCTS T1 სატრანზიტო დოკუმენტის მომზადება საქართველოში",
      desc: "ჩვენ ვთავაზობთ ლოგისტიკურ და გადამზიდავ კომპანიებს NCTS T1 ტრანზიტული დეკლარაციების მომზადებას უმოკლეს დროში.",
      contact: "დაგვიკავშირდით",
      aboutTitle: "ჯეოგლობალგეითის შესახებ",
      aboutText: "ჯეოგლობალგეითი არის საქართველოს ფინანსთა სამინისტროს, შემოსავლების სამსახურის მიერ ლიცენზირებული კომპანია, რომელიც უზრუნველყოფს NCTS T1 დოკუმენტის მომზადებას საქართველოში. ჩვენი მიზანია გავამარტივოთ საბაჟო პროცედურები და დავეხმაროთ კომპანიებს დროისა და რესურსის ოპტიმიზაციაში.",
      aboutWhyTitle: "რატომ ირჩევენ კომპანიები ჯეოგლობალგეითს პარტნიორად?",
      aboutWhyText: "ჩვენთან თანამშრომლობა ნიშნავს სანდოობას, პროფესიონალიზმს და შედეგზე ორიენტირებულ მიდგომას. თითოეულ კლიენტს ვთავაზობთ მის საჭიროებებზე მორგებულ გადაწყვეტილებებს და ვზრუნავთ პროცესის ეფექტურად და გამჭვირვალედ მართვაზე. ჩვენი მიზანი მხოლოდ მომსახურების მიწოდება არ არის — ჩვენ ვქმნით გრძელვადიან პარტნიორობას, რომელიც რეალურად უწყობს ხელს ბიზნესის ზრდასა და განვითარებას. ჩვენი გუნდი მზადყოფნაშია 24/7-ზე, რათა გაგიმარტივოთ NCTS T1 დოკუმენტის მომზადება უმოკლეს ვადებში. მომსახურებას გთავაზობთ დისტანციურად და ელექტრონულად, რაც უზრუნველყოფს სწრაფ, მარტივ და ეფექტურ პროცესს.",
      aboutServicesTitle: "ჩვენი მომსახურება მოიცავს:",
      aboutServiceItem1: "NCTS T1 ტრანზიტის დეკლარაციების მომზადებას.",
      aboutServiceItem2: "საბაჟო დოკუმენტაციის სრულ ადმინისტრირებას.",
      aboutServiceItem3: "საბაჟო ორგანოებთან კოორდინაციას და ოპერატიულ მხარდაჭერას.",
      aboutRepresentativeText: "ჩვენ ვმოქმედებთ, როგორც თქვენი სანდო წარმომადგენელი საბაჟო ტერმინალში და ვუზრუნველვყოფთ ყველა პროცედურის სწორ და დროულ შესრულებას.",
      aboutBestChoiceTitle: "რატომ არის ჯეოგლობალგეითი თქვენი საუკეთესო არჩევანი?",
      aboutBestItem1: "ლიცენზირებული NCTS ოპერატორი საქართველოში",
      aboutBestItem2: "სწრაფი და ეფექტური მომსახურება 24/7-ზე შეფერხების გარეშე",
      aboutBestItem3: "დისტანციური მომსახურება - ადგილზე მისვლის გარეშე",
      aboutBestItem4: "გამოცდილება კომპლექსურ სატრანზიტო გადაზიდვებში",
      aboutCtaText: "დაგვიკავშირდით დღესვე და მიიღეთ სანდო საბაჟო მომსახურება საქართველოში.",
      servicesNavLabel: "სერვისები",
      servicesTitle: "სერვისები",
      servicesSubtitle: "კომპლექსური საბაჟო და სატრანზიტო გადაწყვეტილებები თქვენი ბიზნესისთვის.",
      svc1Title: "NCTS T1 დეკლარაციის სერვისები საქართველოში",
      svc1Item1: "T1 დოკუმენტის სწრაფი მომზადება",
      svc1Item2: "ელექტრონული დამუშავება",
      svc1Item3: "დისტანციური მხარდაჭერა 24/7",
      svc2Title: "საბაჟო საბროკერო მომსახურება",
      svc2Item1: "დეკლარაციების სრული დამუშავება",
      svc2Item2: "T1/T2 დოკუმენტაცია",
      svc2Item3: "რისკის შემცირება",
      svc3Title: "სატრანზიტო მხარდაჭერა",
      svc3Item1: "საბაჟო ორგანოებთან კოორდინაცია",
      svc3Item2: "საზღვრებზე ოპერატიული მხარდაჭერა რეალურ დროში",
      svc3Item3: "პრობლემის გადაჭრა",
      svc4Title: "საკომუნიკაციო მხარდაჭერა",
      svc4Desc: "ჩვენი ცხელი ხაზი მუშაობს 24 საათის განმავლობაში და გთავაზობთ მხარდაჭერას ქართულ, თურქულ, აზერბაიჯანულ, რუსულ, ინგლისურ, უკრაინულ და ესპანურ ენებზე. ეს უზრუნველყოფს სწრაფ, მარტივ და უწყვეტ კომუნიკაციას ნებისმიერ დროს.",
      service1: "საბაჟოს პროცედურები",
      service2: "ექსპერტიზა",
      service3: "ფიტოსანიტარიული სერტიფიკატის აღება",
      service4: "წარმოშობის სერთიფიკატის მიღება",
      service5: "სხვა საბაჟო დოკუმენტების აღება",
      offersTitle: "ტარიფები",
      offerSubtitle: "NCTS T1 სერვისების ფასები",
      column1: "სახელი",
      column2: "საბაჟო დერეფანი",
      column3: "ფასი",
      table1: "საბროკერო მომსახურება",
      table2: "დეკლარაციის მომზადება",
      table3: "დამატებითი კოდი",
      table4: "რთული დეკლარაცია (15-ზე მეტი სასაქონლო კოდი)",
      table5: "ფიტოსანიტარიული სერტიფიკატი",
      table6: "წარმოშობის სერთიფიკატი",
      table7: "ტრანზიტული დეკლარაცია (T1)",
      green: "მწვანე",
      red: "წითელი",
      yellow: "ყვითელი",
      any: "რომელიმე მათგანი",
      warning: "* ფასები განისაზღვრება ერთი საბაჟო დეკლარაციის მიხედვით, ფასში არ შედის საბაჟო მოსაკრებლები და სხვა სახელმწიფო გადასახადები.",
      input1: "კომპანიის დასახელება",
      input2: "თქვენი სახელი",
      input3: "თქვენი იმეილი",
      phoneNumber: "თქვენი ტელეფონის ნომერი",
      vehicleNumber: "მანქანის ნომერი",
      shipmentPrice: "ტვირთის ღირებულება",
      serviceTypeLabel: "რა სერვისი გნებავთ?",
      selectService: "აირჩიეთ სერვისი",
      transit: "ტრანზიტი",
      export: "ექსპორტი",
      evaluationCustomsOffice: "საქართველოს ტერიტორიაზე შეფასების საბაჟო ოფისი",
      exitCustomsOfficeExport: "საქართველოდან გასვლის საბაჟო ოფისი",
      entryCustomsOffice: "საქართველოში შემოსვლის საბაჟო",
      exitCustomsOfficeTransit: "საქართველოდან გასვლის საბაჟო ოფისი",
      route: "მარშრუტი",
      routeInfoTitle: "მარშრუტის შეყვანის ინსტრუქცია",
      routeInfoContent: "მარშრუტში უნდა ჩაწეროთ კონკრეტულად ტრანზიტის საბაჟო ოფისების სახელწოდება/კოდი",
      routeInfoButton: "გასაგებია",
      finalClearanceLocation: "საბოლოო განბაჟების ადგილი",
      requiredDocuments: "საჭირო დოკუმენტები",
      selectFile: "ფაილის არჩევა",
      selectFiles: "ფაილების არჩევა",
      attachFiles: "ფაილების მიმაგრება",
      cmr: "CMR",
      declaration: "ტრანზიტული დეკლარაცია",
      invoice: "ინვოისი",
      packingList: "შეფუთვის ფურცელი",
      vehicleRegistration: "მანქანის პასპორტი",
      driverPassport: "მძღოლის პასპორტი",
      registrationCertificate: "აღრიცხვის მოწმობა ან D ნომრიანი დეკლარაცია",
      input7: "თქვენი შეტყობინება",
      send: "გაგზავნა",
      contactTitle: "მოგვწერეთ რა სერვისი გნებავთ",
      status: "მოთხოვნა გაიგზავნა წარმატებით, დაგიკავშირდებათ კომპანიის წარმომადგენელი",
      error: "მოთხოვნა ვერ გაიგზავნა. სცადეთ მოგვიანებით",
      pleaseUpload: "გთხოვთ ატვირთოთ",
      selectOption: "გთხოვთ აირჩიოთ",
      paymentAmount: "გადასახდელი თანხა",
      carNumber: "მანქანის ნომერი",
      payButton: "გადახდა",
      negotiable: "ინდივიდუალური",
      companyNameRequired: "კომპანიის სახელი სავალდებულოა",
      nameRequired: "სახელი სავალდებულოა",
      emailRequired: "ელ.ფოსტა სავალდებულოა",
      phoneRequired: "ტელეფონის ნომერი სავალდებულოა",
      carNumberRequired: "მანქანის ნომერი სავალდებულოა",
      serviceRequired: "სერვისის ტიპი სავალდებულოა",
      invalidEmail: "ელ.ფოსტის ფორმატი არასწორია",
      evaluationCustomsRequired: "შეფასების საბაჟო ოფისი სავალდებულოა",
      exitCustomsExportRequired: "ექსპორტის გასვლის საბაჟო ოფისი სავალდებულოა",
      entryCustomsRequired: "შესვლის საბაჟო ოფისი სავალდებულოა",
      exitCustomsTransitRequired: "ტრანზიტის გასვლის საბაჟო ოფისი სავალდებულოა",
      routeRequired: "მარშრუტი სავალდებულოა",
      clearanceLocationRequired: "საბოლოო განბაჟების ადგილი სავალდებულოა",
      filesRequired: "ფაილები სავალდებულოა",
      uploaded: "ატვირთულია",
      uploadedFiles: "ატვირთული ფაილები",
      removeAll: "ყველას წაშლა",
      removeFile: "ფაილის წაშლა",
      files: "ფაილი",
      fileTooBig: "ფაილი ძალიან დიდია",
      totalSizeExceeded: "ჯამური ზომა გადაჭარბებულია",
      filesAddedSuccess: "ფაილ(ებ)ი წარმატებით დაემატა",
      allFilesRemoved: "ყველა ფაილი წაიშალა",
      acceptTerms: "ვეთანხმები",
      selectCurrency: "აირჩიეთ ვალუტა",
      termsAndConditions: "წესებს და პირობებს",
      termsRequired: "თქვენ უნდა დაეთანხმოთ წესებს და პირობებს",
      termsTitle: "წესები და პირობები",
      termsContent: `ჯეოგლობალგეითი – წესები და პირობები

I. ზოგადი დებულებები
კომპანია ჯეოგლობალგეითი უზრუნველყოფს საბაჟო და სატრანზიტო მომსახურებას მოქმედი კანონმდებლობის შესაბამისად.
კლიენტის მიერ პირობების დადასტურება წარმოადგენს სამართლებრივად სავალდებულო შეთანხმებას.

II. სერვისების სრული აღწერა
კომპანია უზრუნველყოფს შემდეგ მომსახურებებს:
• ტვირთის სპეციფიკის, მარშრუტისა და საბაჟო მოთხოვნების შესახებ კონსულტაცია;
• სრული საბაჟო დოკუმენტაციის მომზადება: ინვოისი, შეფუთვის ფურცელი, სატრანსპორტო ზედნადები (CMR / Bill of Lading / Airway Bill), წარმოშობის სერტიფიკატი, იმპორტ-ექსპორტის ნებართვები და საბაჟო დეკლარაციები;
• საბაჟო რეგულაციების დაცვის მონიტორინგი და საბაჟო ორგანოებთან ურთიერთობა;
• გადასახადებისა და მოსაკრებლების გაანგარიშება;
• რისკების მართვა და კონსულტაციები სავაჭრო და ბაჟის გადახდის საკითხებზე;
• ტრანზიტის პროცედურების მართვა, MRN კოდის მონიტორინგი და დანიშნულების საბაჟოში დახურვა.

III. მომსახურების სრული პირობები
• კლიენტი ვალდებულია მიაწოდოს სრული და სწორი დოკუმენტაცია. არასწორი ან არასრული ინფორმაციის მიწოდების შემთხვევაში კომპანია არ იღებს პასუხისმგებლობას დაგვიანებაზე ან ჯარიმებზე.
• კომპანია იწყებს მომსახურების გაწევას მხოლოდ სრული დოკუმენტაციისა და გადახდის დადასტურების შემდეგ.
• კომპანიას უფლება აქვს უარი თქვას მომსახურებაზე, თუ კლიენტი არ ასრულებს მოთხოვნებს ან არ უზრუნველყოფს საჭირო მონაცემებს.

IV. სერვისის გაწევის ვადები
• T1 დეკლარაციის მომზადება ხდება მაქსიმუმ 1 საათში სრული დოკუმენტაციისა და გადახდის დადასტურების შემდეგ.
• სხვა მომსახურებების ვადები განისაზღვრება ინდივიდუალურად და წინასწარ ეცნობება კლიენტს.

V. გაუქმება და თანხის დაბრუნება
გაუქმება:
• T1 დეკლარაციის გაუქმება შესაძლებელია მხოლოდ საბაჟო პროცედურების დაწყებამდე.
• თუ ტვირთი უკვე „გაშვებულია", გაუქმება შეუძლებელია.
• გაუქმების შემთხვევაში კლიენტი იხდის 100 ლარის მომსახურების საფასურს.

თანხის დაბრუნება:
• თანხა დაბრუნდება მხოლოდ იმავე ანგარიშზე ან ბარათზე, საიდანაც განხორციელდა გადახდა.
• თანხის დაბრუნების ვადა შეადგენს მაქსიმუმ 14 კალენდარულ დღეს მოთხოვნის დამუშავებიდან.
• ყველა ადმინისტრაციული ხარჯი წინასწარ ეცნობება კლიენტს.

VI. დავების მართვის პოლიტიკა
• ყველა პრეტენზია და დავა უნდა გაიგზავნოს ელ-ფოსტაზე: support@geoglobalgate.com.
• კომპანია ვალდებულია განიხილოს კლიენტის საჩივარი არაუგვიანეს 10 სამუშაო დღისა.
• თუ მხარეები ვერ შეთანხმდებიან, დავა განიხილება საქართველოს მოქმედი კანონმდებლობის შესაბამისად საქართველოს სასამართლოში.

VII. მონაცემთა დაცვა
კლიენტის პერსონალური მონაცემები მუშავდება მხოლოდ მომსახურების გაწევის მიზნით და მოქმედი კანონმდებლობის შესაბამისად.`,
      successModalTitle: "განაცხადი მიღებულია",
      successModalCompany: `კომპანია "ჯეოგლობალგეითმა" მიიღო თქვენი განაცხადი.`,
      successModalMessage: "ჩვენი მენეჯერი მალე დაგიკავშირდებათ.",
      successModalClose: "დახურვა",
      navFaq: "FAQ",
      faqTitle: "ხშირად დასმული კითხვები (FAQ)",
      faq1Q: "ვინ უზრუნველყოფს NCTS T1 მომსახურებას საქართველოში?",
      faq1A: "ჯეოგლობალგეითი არის ლიცენზირებული NCTS ოპერატორი საქართველოში და გთავაზობთ სრულ მომსახურებას ტრანზიტული T1 დეკლარაციების, საბაჟო პროცესებისა და საერთაშორისო გადაზიდვების მართვის მიმართულებით.",
      faq2Q: "ვისთვის არის თქვენი მომსახურება განკუთვნილი?",
      faq2A: "ჯეოგლობალგეითი თანამშრომლობს როგორც მცირე და საშუალო ბიზნესთან, ასევე დიდ კომპანიებთან, რომლებიც ეძებენ სანდო და ეფექტურ პარტნიორს.",
      faq3Q: "როგორ იწყება თანამშრომლობა?",
      faq3A: "თანამშრომლობა იწყება თქვენი საჭიროებების დეტალური ანალიზით, რის შემდეგაც გთავაზობთ კონკრეტულ, თქვენზე მორგებულ გადაწყვეტას.",
      faq3Step1: "მოგვაწოდეთ გადაზიდვის დეტალები",
      faq3Step2: "ჩვენ მოვამზადებთ თქვენს T1 დეკლარაციას",
      faq3Step3: "T1 დოკუმენტს მიიღებთ რამდენიმე წუთის განმავლობაში",
      faq3Step4: "თქვენი სატრანსპორტო საშუალება გადაადგილდება შეფერხების გარეშე",
      faq4Q: "რამდენად სწრაფად ხდება მომსახურების მიწოდება?",
      faq4A: "ჩვენი გუნდი უზრუნველყოფს პროცესების მაქსიმალურად სწრაფ და ეფექტურ შესრულებას, ხარისხის მაღალი სტანდარტების დაცვით. NCTS T1 დოკუმენტის მომზადებას ვახორციელებთ სრულყოფილი დოკუმენტაციის მიღებიდან 10–20 წუთის განმავლობაში.",
      faq5Q: "როგორ შემიძლია თქვენთან დაკავშირება?",
      faq5A: "ჩვენთან დაკავშირება შეგიძლიათ ვებსაიტზე მითითებული საკონტაქტო ნომრების საშუალებით, ასევე ელ. ფოსტით. გარდა ამისა, განაცხადის გამოგზავნა შესაძლებელია ელექტრონულად ჩვენი პორტალის მეშვეობით.",
      // NCTS სექცია
      nctsTitle: "NCTS ტრანზიტის სისტემა",
      nctsIntro: "NCTS არის ერთიანი ციფრული საბაჟო სისტემა, რომელიც ამარტივებს და აჩქარებს ტრანზიტულ პროცედურებს ევროპასა და პარტნიორ ქვეყნებში, მათ შორის საქართველოშიც.",
      nctsWhat: "რა არის NCTS?",
      t1BenefitsTitle: "T1 ბენეფიტები",
      nctsDescription: "აბრევიატურა NCTS აღნიშნავს „საერთო ტრანზიტის პროცედურის შესახებ კონვენციით გათვალისწინებულ ახალ კომპიუტერიზებულ სატრანზიტო სისტემას (New Computerised Transit System), რომელიც საშუალებას იძლევა, მასში შევსებული ტრანზიტის დეკლარაციით საქონელი გადაადგილდეს:",
      nctsMovement1: "CTC-ის წევრი ქვეყნიდან CTC-ის წევრი ქვეყნის დანიშნულებით",
      nctsMovement2: "მესამე ქვეყნიდან CTC-ის წევრი ქვეყნის დანიშნულებით",
      nctsMovement3: "CTC-ის წევრი ქვეყნიდან მესამე ქვეყნის გავლით CTC-ის წევრი ქვეყნის დანიშნულებით",
      nctsMovement4: "CTC-ის წევრი ქვეყნიდან მესამე ქვეყნის დანიშნულებით",
      ctcCountriesTitle: "CTC-ის წევრი ქვეყნები",
      ctcCountriesIntro: "CTC (Common Transit Convention) მოიცავს:",
      ctcCountryEU: "ევროკავშირის ყველა ქვეყანას (ბელგია, ბულგარეთი, ჩეხეთი, დანია, გერმანია, ესტონეთი, ირლანდია, საბერძნეთი, ესპანეთი, საფრანგეთი და სხვ.)",
      ctcCountrySwitzerland: "შვეიცარია",
      ctcCountryNorway: "ნორვეგია",
      ctcCountryIceland: "ისლანდია",
      ctcCountryMacedonia: "ჩრდილოეთ მაკედონია",
      ctcCountrySerbia: "სერბეთი",
      ctcCountryTurkey: "თურქეთი",
      ctcCountryUK: "გაერთიანებული სამეფო",
      ctcCountryGeorgia: "საქართველოს რესპუბლიკა",
      nctsImportanceTitle: "რატომ არის მნიშვნელოვანი NCTS?",
      nctsSimplification: "საბაჟო პროცესების გამარტივება",
      nctsSimplificationDesc: "დოკუმენტაცია ავტომატიზებულია. საბაჟო ორგანოები რეალურ დროში აკონტროლებენ ტვირთს გამგზავნიდან დანიშნულებამდე, რაც ამცირებს ფორმალობებს და დროულად ავლენს პრობლემებს.",
      nctsControl: "ტრანზიტის კონტროლის გაუმჯობესება",
      nctsControlDesc: "შესაძლებელია ტვირთის მარშრუტის სრული მონიტორინგი. ნებისმიერი შეფერხება ან გადახვევა სისტემაში დაუყოვნებლივ ფიქსირდება.",
      nctsSpeed: "სიჩქარე და გამჭვირვალობა",
      nctsSpeedDesc: "პროცედურები დაჩქარებულია და ბიუროკრატიული ჩარევა მინიმალურია. ეს ამცირებს დაკარგვის ან უკანონო გადაზიდვის რისკს.",
      nctsEfficiency: "საერთაშორისო ეფექტიანობა",
      nctsEfficiencyDesc: "ევროკავშირის გარდა, სისტემაში ჩართულნი არიან პარტნიორი ქვეყნები, რაც ზრდის ტრანსსასაზღვრო თანამშრომლობის ხარისხს.",
      t1FormTitle: "T1 ფორმის მნიშვნელობა",
      t1FormDesc: "T1 ფორმა არის საერთაშორისო ტრანზიტის ძირითადი დოკუმენტი, რომელიც იძლევა ერთდროულად იურიდიულ და ოპერატიულ გარანტიას:",
      t1Benefit1: "აზღვევს ტვირთს სამართლებრივი თვალსაზრისით და ოფიციალურად აფიქსირებს საბაჟო სისტემაში.",
      t1Benefit2: "ათავისუფლებს იმპორტის გადასახადების წინასწარ გადახდისგან, სანამ ტვირთი საბოლოო დანიშნულების ადგილს არ მიაღწევს.",
      t1Benefit3: "ამარტივებს გადაადგილებას და ამცირებს დროსა და რესურსებს.",
      t1Benefit4: "იცავს პროცესს შეფერხებებისგან, რადგან საბაჟო უწყებები დარწმუნებული არიან, რომ ტვირთი კონტროლდება.",
      t1PreparationTitle: "როგორ მზადდება T1 ფორმა?",
      t1PreparationDesc: "სწორად შედგენილი T1 მოითხოვს:",
      t1Requirement1: "ზუსტ და დეტალურ ინფორმაციას ტვირთზე",
      t1Requirement2: "გამგზავნისა და მიმღების სრულ მონაცემებს",
      t1Requirement3: "მარშრუტის და საზღვრის გადაკვეთის დეტალებს",
      t1Requirement4: "წვდომას სპეციალურ საბაჟო სისტემებთან (მაგ. NCTS)",
      t1Recommendation: "სწორედ ამიტომ რეკომენდებულია T1 ფორმის მომზადება პროფესიონალი საბაჟო აგენტის ან ლოგისტიკური სპეციალისტის მიერ.",
      nctsConclusion: "დასკვნა",
      nctsConclusionText: "NCTS უკვე აღარ არის არჩევანი — ეს არის აუცილებლობა. მისი დანერგვა ნიშნავს უფრო სწრაფ, უსაფრთხო და პროგნოზირებად ტრანზიტს. კომპანიებისთვის, რომლებიც სთავაზობენ საერთაშორისო გადაზიდვებს, სისტემაში ინტეგრაცია წარმატებული ოპერირების მთავარი პირობაა გლობალურ ბაზარზე.",
      heroCta: "მიიღეთ თქვენი NCTS T1 დეკლარაცია რამდენიმე წუთში!",
      aboutBestItem5: "გამოცდილება რთული სატრანზიტო საქმეებში",
      aboutGuarantee: "ჯეოგლობალგეითი, როგორც ლიცენზირებული ტრანზიტის ოპერატორი, უზრუნველყოფს სრულ საგარანტიო დაფარვას ყველა გადაზიდვაზე. საგარანტიო რეგისტრაცია და აღრიცხვა ხორციელდება სრული შესაბამისობით NCTS ტრანზიტული სისტემის მეშვეობით.",
      howWeWorkTitle: "როგორ ვმუშაობთ",
      howWeWorkSubtitle: "მარტივი და გამჭვირვალე საბაჟო გაფორმების პროცესი",
      howWeWorkStep1Title: "მოთხოვნა",
      howWeWorkStep1Desc: "გამოგვიგზავნეთ თქვენი დოკუმენტები და ტვირთის დეტალები ელ.ფოსტით ან კონტაქტის ფორმის მეშვეობით. მენეჯერი დაგიკავშირდებათ დეტალების დასადასტურებლად.",
      howWeWorkStep2Title: "ანალიზი",
      howWeWorkStep2Desc: "ვამოწმებთ თქვენს დოკუმენტაციას, ვადგენთ სწორ სატრანზიტო პროცედურას და ვაანგარიშებთ საბაჟო გაფორმების მოთხოვნებს.",
      howWeWorkStep3Title: "დამუშავება",
      howWeWorkStep3Desc: "ვამზადებთ და ვაგზავნით NCTS T1 დეკლარაციას ყველა დოკუმენტის მიღებიდან 10–20 წუთის განმავლობაში.",
      howWeWorkStep4Title: "გაშვება",
      howWeWorkStep4Desc: "თქვენი ტვირთი გაიფორმება და გაიშვება. ვაკონტროლებთ MRN-ს დანიშნულების საბაჟოში სრულ დახურვამდე.",
      whoWeWorkWithTitle: "ვისთან ვთანამშრომლობთ",
      whoWeWorkWithSubtitle: "ვემსახურებით ლოგისტიკისა და ვაჭრობის სექტორის კლიენტების ფართო სპექტრს.",
      clientType1: "სატრანსპორტო კომპანიები",
      clientType2: "სატვირთო გადამზიდავი კომპანიები",
      clientType3: "ექსპორტიორები და იმპორტიორები",
      clientType4: "ლოგისტიკური ოპერატორები",
      clientType5: "საბაჟო ბროკერები",
      whereWeOperateTitle: "ოპერირების არეალი",
      whereWeOperateIntro: "ჯეოგლობალგეითი ფარავს ყველა ძირითად საბაჟო პუნქტს, რაც უზრუნველყოფს ტრანზიტის პროცესის სწრაფ და გამართულ მართვას. ჩვენი სერვისები სცდება ქვეყნის ფარგლებს და მოიცავს გადაზიდვებს როგორც ევროკავშირის მიმართულებით, ასევე, სხვა ქვეყნების: თურქეთი, აზერბაიჯანი, სომხეთი, რუსეთი, ყაზახეთი, ჩინეთი, უკრაინა, მოლდოვა და სხვა. სადაც არ უნდა გადაადგილდებოდეს თქვენი ტვირთი, ჩვენ გთავაზობთ სანდო მხარდაჭერასა და სრულ კოორდინაციას.",
      whereWeOperateGeorgia: "საქართველო — ყველა ძირითადი საბაჟო პუნქტი",
      whereWeOperateCountries: "ევროკავშირი, თურქეთი, აზერბაიჯანი, სომხეთი, რუსეთი, ყაზახეთი, ჩინეთი, უკრაინა, მოლდოვა და სხვა",
      whereWeOperateBorders: "სარფი, ვალე, ლარსი, წითელი ხიდი, კარწახი, ლაგოდეხი და სხვ.",
      coverageLabel: "დაფარული ტერიტორიები",
      coverageItem1: "საქართველო",
      coverageItem2: "გამტარები: სარფი, ვალე, ლარსი, წითელი ხიდი, კარწახი, ლაგოდეხი და სხვ.",
      coverageItem3: "ტრანზიტი: ევროკავშირი, თურქეთი, აზერბაიჯანი, სომხეთი, რუსეთი, ყაზახეთი, ჩინეთი…",
      statsTitle: "GeoGlobalGate — ციფრებში",
      statDeclarationsValue: "43,389+",
      statDeclarations: "T1/T2 დეკლარაცია გაფორმებული",
      statCountriesValue: "37",
      statCountries: "ქვეყანა მოცული",
      statClientsValue: "1,570+",
      statClients: "კმაყოფილი კლიენტი",
      statSpeedValue: "10–20 წთ",
      statSpeed: "საშუალო დამუშავების დრო",
      faq6Q: "რა დოკუმენტებია საჭირო T1 დეკლარაციის გასაფორმებლად?",
      faq6A: "T1 დეკლარაციის მოსამზადებლად ჩვეულებრივ გვჭირდება:",
      faq6Step1: "ინვოისი",
      faq6Step2: "შეფუთვის ფურცელი (საჭიროების შემთხვევაში)",
      faq6Step3: "სატრანსპორტო ზედდებული (CMR)",
      faq6Step4: "ექსპორტის/ტრანზიტის დეკლარაცია",
      faq6Step5: "მძღოლისა და სატრანსპორტო საშუალების პასპორტები",
      faq6Step6: "სრული მარშრუტი",
      faq6Closing: "დამატებითი ინფორმაციის საჭიროების შემთხვევაში ჩვენი გუნდი დაგიკავშირდებათ.",
      faq7Q: "ხელმისაწვდომია თქვენი სერვისი 24 საათის განმავლობაში?",
      faq7A: "დიახ, ჩვენ ვმუშაობთ გვიან საათებშიც, რათა თქვენი გადაზიდვების მხარდაჭერა ნებისმიერ დროს იყოს უზრუნველყოფილი.",
      faq7A2: "ჩვენ გვესმის, რომ ლოჯისტიკა უწყვეტი პროცესია, ამიტომ ჩვენი გუნდი მზად არის თქვენს დასახმარებლად 24 საათის განმავლობაში - ღამით, შაბათ-კვირას და დღესასწაულებზეც.",
      careerBadge: "ვეძებთ თანამშრომლებს",
      careerTitle: "დაიწყე შენი კარიერა GeoGlobalGate-ში",
      careerP1: "ჯეოგლობალგეითი მხარს უჭერს კომპანიებს საერთაშორისო ბაზრებზე საბაჟო და სატრანზიტო პროცედურების კომპლექსური პროცესების ეფექტურად მართვაში.",
      careerP2: "ჩვენ ვართ მზარდი ორგანიზაცია და მუდმივად ვეძებთ მოტივირებულ პროფესიონალებს, რომლებიც ორიენტირებულნი არიან პროფესიულ განვითარებასა და გრძელვადიან კარიერულ ზრდაზე.",
      careerP3: "თუ გაქვთ გამოცდილება საბაჟო სფეროში, ლოგისტიკაში, საერთაშორისო ვაჭრობაში ან მზად ხართ ახალი პროფესიული გამოწვევებისთვის, მოხარულები ვიქნებით გავეცნოთ თქვენს რეზიუმეს.",
      careerP4: "ჩვენ გთავაზობთ დინამიკურ და მხარდამჭერ სამუშაო გარემოს, სადაც გექნებათ შესაძლებლობა განავითაროთ თქვენი პროფესიული კომპეტენციები და ჩაერთოთ რეალურ, საერთაშორისო სატრანზიტო ოპერაციებში.",
      careerP5: "ასევე მივესალმებით იმ კანდიდატებს, რომლებიც გეგმავენ ამ სფეროში კარიერის დაწყებას, რადგან GeoGlobalGate შეიძლება გახდეს თქვენი პროფესიული განვითარების მნიშვნელოვანი ეტაპი.",
      careerCta: "📩 გთხოვთ დაგვიკავშირდეთ ან გამოგვიგზავნოთ თქვენი CV შემდეგ ელექტრონულ მისამართზე:",
      customerServiceSubtitle: "პასუხები თქვენს კითხვებზე",
      customerServiceP1: "ჩვენ ვზრუნავთ, რომ თქვენი მოთხოვნა უმოკლეს დროში მოხვდეს სწორ სპეციალისტთან.",
      customerServiceP2: "იქნება ეს ტრანზიტი, საბაჟო პროცედურები თუ ტვირთის კოორდინაცია — ჩვენ ვუზრუნველვყოფთ, რომ თითოეული საკითხი შესაბამის გუნდში გადამისამართდეს.",
      customerServiceTagline: "მკაფიო კომუნიკაცია. სწრაფი გადაწყვეტა.",
      footerFollowUs: "Follow Us",
      footerRights: "© 2026 ჯეოგლობალგეითი — ყველა უფლება დაცულია",
      navHowWeWork: "როგორ ვმუშაობთ",
      navCareer: "კარიერა",
      navStats: "ციფრებში"
    },
  },
  ru: {
    translation: {
      navHome: "Главное",
      navAbout: "О нас",
      navServices: "Сервисы (Услуги)",
      navOffers: "Тарифы",
      navContact: "Контакт",
      welcome: "Подготовка транзитного документа NCTS T1 в Грузии",
      desc: "Мы предлагаем услуги по оформлению деклараций NCTS T1 в Грузии и помогаем компаниям быстро и легко оформить транзитные документы T1",
      contact: "Контакт",
      aboutTitle: "О компании GeoGlobalGate LTD",
      aboutText: "GeoGlobalGate LTD — компания, лицензированная Министерством финансов Грузии, Службой доходов, обеспечивающая подготовку документа NCTS T1 в Грузии. Наша цель — упростить таможенные процедуры и помочь компаниям оптимизировать время и ресурсы.",
      aboutWhyTitle: "Почему компании выбирают GeoGlobalGate LTD в качестве партнёра?",
      aboutWhyText: "Сотрудничество с нами означает надёжность, профессионализм и ориентацию на результат. Каждому клиенту мы предлагаем решения, адаптированные под его потребности, и обеспечиваем эффективное и прозрачное управление процессом. Наша цель — не просто оказать услугу, а выстроить долгосрочное партнёрство, которое реально способствует росту и развитию бизнеса. Наша команда готова 24/7, чтобы помочь вам оформить документ NCTS T1 в кратчайшие сроки. Услуги оказываются дистанционно и в электронном виде, что обеспечивает быстрый, простой и эффективный процесс.",
      aboutServicesTitle: "Наши услуги включают:",
      aboutServiceItem1: "Подготовку транзитных деклараций NCTS T1.",
      aboutServiceItem2: "Полное администрирование таможенной документации.",
      aboutServiceItem3: "Координацию с таможенными органами и оперативную поддержку.",
      aboutRepresentativeText: "Мы выступаем в роли вашего надёжного представителя на таможенном терминале и обеспечиваем правильное и своевременное выполнение всех процедур.",
      aboutBestChoiceTitle: "Почему GeoGlobalGate LTD — ваш лучший выбор?",
      aboutBestItem1: "Лицензированный оператор NCTS в Грузии",
      aboutBestItem2: "Работаем 24/7 – без задержек",
      aboutBestItem3: "Дистанционное обслуживание – присутствие не требуется",
      aboutBestItem4: "Опыт работы со сложными транзитными перевозками",
      aboutCtaText: "Свяжитесь с нами сегодня и получите надёжные таможенные услуги в Грузии.",
      servicesNavLabel: "Услуги",
      servicesTitle: "Наши Услуги",
      servicesSubtitle: "Комплексные таможенные и транзитные решения для вашего бизнеса.",
      svc1Title: "Услуги по оформлению NCTS T1 в Грузии",
      svc1Item1: "Быстрая подготовка T1 документов",
      svc1Item2: "Электронная обработка",
      svc1Item3: "Удалённая поддержка 24/7",
      svc2Title: "Таможенный брокераж",
      svc2Item1: "Полное оформление деклараций",
      svc2Item2: "Документация T1/T2",
      svc2Item3: "Снижение рисков",
      svc3Title: "Транзитная поддержка",
      svc3Item1: "Координация с таможенными органами",
      svc3Item2: "Помощь на границе в режиме реального времени",
      svc3Item3: "Решение проблем",
      svc4Title: "Коммуникационная поддержка",
      svc4Desc: "Наша горячая линия работает 24/7, предоставляя многоязычную поддержку на грузинском, турецком, азербайджанском, русском, английском, украинском и испанском языках, обеспечивая чёткую и эффективную связь в любое время.",
      service1: "Таможенные Процедуры",
      service2: "Экспертиза",
      service3: "Получение Фито-Санитарного Сертификата",
      service4: "Получение Сертификата Происхождения",
      service5: "Получение Прочих Таможенных Документов",
      offersTitle: "Тарифы",
      offerSubtitle: "Цены на услуги NCTS T1",
      column1: "Имя",
      column2: "Таможенный коридор",
      column3: "Цена",
      table1: "Брокерные Услуги",
      table2: "Подготовление Декларации",
      table3: "Дополнительный Код",
      table4: "Сложная декларация (более 15 товарных кодов)",
      table5: "Фитосанитарный сертификат",
      table6: "Сертификат происхождения",
      table7: "Транзитная декларация (T1)",
      green: "Зеленый",
      red: "Красный",
      yellow: "Желтый",
      any: "Любой из них",
      warning: "* Цена Определяется на Основе Одной Таможенной Декларации, Цена не Включает в Себя Таможенные Пошлины и Прочие Государственные Налоги.",
      input1: "Название Организации (Компании)",
      input2: "Ваше Имя",
      input3: "Ваша Электронная Почта",
      phoneNumber: "Ваш Номер Телефона",
      vehicleNumber: "Номер Транспортного Средства",
       shipmentPrice: "Стоимость груза",
      serviceTypeLabel: "Какая услуга вам требуется?",
      selectService: "Выберите услугу",
      transit: "Транзит",
      export: "Экспорт",
      evaluationCustomsOffice: "Таможенный пункт оценки на территории Грузии",
      exitCustomsOfficeExport: "Таможенный пункт выезда из Грузии",
      entryCustomsOffice: "Таможенный пункт въезда в Грузию",
      exitCustomsOfficeTransit: "Таможенный пункт выезда из Грузии",
      route: "Маршрут",
      routeInfoTitle: "Инструкция по вводу маршрута",
      routeInfoContent: "В маршруте необходимо указать конкретные названия/коды транзитных таможенных пунктов",
      routeInfoButton: "Понятно",
      finalClearanceLocation: "Место окончательного таможенного оформления",
      requiredDocuments: "Необходимые документы",
      selectFile: "Выбрать файл",
      selectFiles: "Выбрать файлы",
      attachFiles: "Прикрепить файлы",
      cmr: "CMR",
      declaration: "транзитная декларация",
      invoice: "Инвойс",
      packingList: "Упаковочный лист",
      vehicleRegistration: "Техпаспорт",
      driverPassport: "Паспорт водителя",
      registrationCertificate: "Регистрационное свидетельство или декларация с номером D",
      input7: "Ваше Сообщение",
      send: "Отправить",
      contactTitle: "Пишите Нам об Услугах Которые Вам Требуются",
      status: "Ваш запрос отправлен, представитель компании свяжется с вами.",
      error: "Запрос не может быть отправлен. Попробуйте еще раз позже.",
      pleaseUpload: "Пожалуйста, загрузите",
      selectOption: "Пожалуйста, выберите",
      paymentAmount: "Сумма к оплате",
      carNumber: "Номер автомобиля",
      payButton: "Оплатить",
      negotiable: "индивидуальный",
      companyNameRequired: "Название компании обязательно",
      nameRequired: "Имя обязательно",
      emailRequired: "Электронная почта обязательна",
      phoneRequired: "Номер телефона обязателен",
      carNumberRequired: "Номер машины обязателен",
      serviceRequired: "Тип услуги обязателен",
      invalidEmail: "Неверный формат электронной почты",
      evaluationCustomsRequired: "Таможенный офис оценки обязателен",
      exitCustomsExportRequired: "Выходной таможенный офис для экспорта обязателен",
      entryCustomsRequired: "Входной таможенный офис обязателен",
      exitCustomsTransitRequired: "Выходной таможенный офис для транзита обязателен",
      routeRequired: "Маршрут обязателен",
      selectCurrency: "Выберите валюту",
      clearanceLocationRequired: "Место окончательного таможенного оформления обязательно",
      filesRequired: "Файлы обязательны",
      uploaded: "Загружено",
      uploadedFiles: "Загруженные файлы",
      removeAll: "Удалить все",
      removeFile: "Удалить файл",
      files: "файлов",
      fileTooBig: "Файл слишком большой",
      totalSizeExceeded: "Превышен общий размер",
      filesAddedSuccess: "файл(ы) успешно добавлены",
      allFilesRemoved: "Все файлы удалены",
      acceptTerms: "Я принимаю",
      termsAndConditions: "Правила и Условия",
      termsRequired: "Вы должны принять правила и условия",
      termsTitle: "Правила и Условия",
      t1BenefitsTitle: "Преимущества T1",
      termsContent: `GeoGlobalGate – Правила и Условия

I. Общие положения
Компания GeoGlobalGate оказывает таможенные и транзитные услуги в соответствии с действующим законодательством.
Подтверждение условий Клиентом является юридически обязательным соглашением.

II. Полное описание услуг
Компания предоставляет следующие услуги:
• Консультации по специфике груза, маршрутам и требованиям таможни;
• Подготовка полного пакета документов: инвойс, упаковочный лист, транспортные документы (CMR / Bill of Lading / Airway Bill), сертификат происхождения, разрешения на импорт-экспорт и таможенные декларации;
• Контроль соблюдения таможенных правил и взаимодействие с таможенными органами;
• Расчёт налогов и сборов;
• Управление рисками и консультации по вопросам торговли и таможенных платежей;
• Управление транзитными процедурами, мониторинг MRN и закрытие в таможне назначения.

III. Полные условия обслуживания
• Клиент обязан предоставить полный и достоверный пакет документов. Компания не несёт ответственности за задержки или штрафы, вызванные неверными или неполными данными.
• Услуги начинаются только после получения полного пакета документов и подтверждения оплаты.
• Компания вправе отказать в оказании услуг, если Клиент не выполняет требования или не предоставляет необходимые сведения.

IV. Сроки оказания услуг
• Подготовка T1 декларации осуществляется в течение 1 часа после получения полного пакета документов и подтверждения оплаты.
• Сроки по другим услугам устанавливаются индивидуально и сообщаются Клиенту заранее.

V. Отмена и Возврат
Отмена:
• Отмена T1 декларации возможна только до начала таможенных процедур.
• Если груз уже «выпущен», отмена невозможна.
• В случае отмены Клиент оплачивает комиссию в размере 100 лари.

Возврат:
• Возврат средств осуществляется только на тот же счёт или карту, с которых была произведена оплата.
• Возврат средств производится в течение максимум 14 календарных дней со дня получения запроса.
• Все административные расходы сообщаются Клиенту заранее.

VI. Политика разрешения споров
• Все претензии и споры должны направляться на email: support@geoglobalgate.com.
• Компания обязуется рассмотреть жалобу Клиента не позднее чем в течение 10 рабочих дней.
• В случае недостижения соглашения спор подлежит рассмотрению в соответствии с законодательством Грузии в судах Грузии.

VII. Защита данных
Персональные данные Клиента обрабатываются исключительно для оказания услуг и в соответствии с действующим законодательством.`,
      // NCTS секция
      nctsTitle: "NCTS транзитная система",
      nctsIntro: "NCTS — это единая цифровая таможенная система, которая упрощает и ускоряет транзитные процедуры в Европе и странах-партнёрах, включая Грузию.",
      nctsWhat: "Что такое NCTS?",
      nctsDescription: "Аббревиатура NCTS означает Новую компьютеризированную транзитную систему, предусмотренную Конвенцией о общем транзите (CTC). Она позволяет перемещать товары по единой транзитной декларации в следующих случаях:",
      nctsMovement1: "Из страны-участницы CTC в другую страну-участницу CTC",
      nctsMovement2: "Из третьей страны в страну-участницу CTC",
      nctsMovement3: "Из страны-участницы CTC через третью страну в другую страну-участницу CTC",
      nctsMovement4: "Из страны-участницы CTC в третью страну",
      ctcCountriesTitle: "Страны-участницы CTC",
      ctcCountriesIntro: "CTC (Common Transit Convention) включает:",
      ctcCountryEU: "Все страны ЕС (Бельгия, Болгария, Чехия, Дания, Германия, Эстония, Ирландия, Греция, Испания, Франция и др.)",
      ctcCountrySwitzerland: "Швейцарию",
      ctcCountryNorway: "Норвегию",
      ctcCountryIceland: "Исландию",
      ctcCountryMacedonia: "Северную Македонию",
      ctcCountrySerbia: "Сербию",
      ctcCountryTurkey: "Турцию",
      ctcCountryUK: "Великобританию",
      ctcCountryGeorgia: "Грузию",
      nctsImportanceTitle: "Почему NCTS важна?",
      nctsSimplification: "Упрощение таможенных процедур",
      nctsSimplificationDesc: "Документация автоматизирована, таможенные органы контролируют груз в режиме реального времени, что сокращает формальности и предупреждает задержки.",
      nctsControl: "Усиленный контроль",
      nctsControlDesc: "Маршрут груза полностью отслеживается, любые отклонения или задержки сразу фиксируются в системе.",
      nctsSpeed: "Скорость и прозрачность",
      nctsSpeedDesc: "Процедуры проходят быстрее, при минимальном вмешательстве бюрократии, что снижает риски потери или незаконной перевозки.",
      nctsEfficiency: "Международная эффективность",
      nctsEfficiencyDesc: "Помимо стран ЕС, система включает партнёров, что значительно улучшает трансграничное сотрудничество.",
      t1FormTitle: "Значение формы T1",
      t1FormDesc: "Форма T1 — основной документ международного транзита, который обеспечивает юридические и операционные гарантии:",
      t1Benefit1: "Юридически закрепляет груз, официально регистрируя его в таможенной системе",
      t1Benefit2: "Освобождает от необходимости предварительной уплаты импортных пошлин до прибытия груза в конечный пункт назначения",
      t1Benefit3: "Упрощает перемещение и снижает затраты времени и ресурсов",
      t1Benefit4: "Защищает логистический процесс от задержек, так как таможенные органы знают, что груз находится под контролем",
      t1PreparationTitle: "Как оформляется форма T1?",
      t1PreparationDesc: "Правильно оформленная форма T1 требует:",
      t1Requirement1: "Точной и детальной информации о грузе",
      t1Requirement2: "Полных данных об отправителе и получателе",
      t1Requirement3: "Маршрута и деталей пересечения границ",
      t1Requirement4: "Доступа к специализированным таможенным системам (например, NCTS)",
      t1Recommendation: "Поэтому рекомендуется поручить подготовку формы T1 профессиональному таможенному агенту или логистическому специалисту.",
      nctsConclusion: "Заключение",
      nctsConclusionText: "NCTS — это уже не выбор, а необходимость. Её внедрение обеспечивает более быстрый, безопасный и прогнозируемый транзит. Для компаний, предлагающих международные перевозки, интеграция в систему — ключевое условие успешной работы на мировом рынке.",
      heroCta: "Оформите декларацию NCTS T1 за считанные минуты!",
      aboutBestItem5: "Опыт работы со сложными транзитными случаями",
      aboutGuarantee: "GeoGlobalGate LTD, как авторизованный транзитный оператор, обеспечивает полное гарантийное покрытие всех грузоперевозок. Регистрация и учёт гарантий осуществляются в полном соответствии с требованиями системы NCTS.",
      howWeWorkTitle: "Как мы работаем",
      howWeWorkSubtitle: "Простой и прозрачный процесс таможенного оформления",
      howWeWorkStep1Title: "Запрос",
      howWeWorkStep1Desc: "Вы отправляете нам документы и данные о грузе по электронной почте или через контактную форму. Наш менеджер свяжется с вами для подтверждения деталей.",
      howWeWorkStep2Title: "Анализ",
      howWeWorkStep2Desc: "Мы проверяем вашу документацию, определяем корректную транзитную процедуру и рассчитываем требования к таможенному оформлению.",
      howWeWorkStep3Title: "Обработка",
      howWeWorkStep3Desc: "Мы подготавливаем и подаём декларацию NCTS T1 в течение 10–20 минут после получения всех документов.",
      howWeWorkStep4Title: "Выпуск",
      howWeWorkStep4Desc: "Ваш груз оформляется и выпускается. Мы отслеживаем MRN до полного закрытия на таможне назначения.",
      whoWeWorkWithTitle: "С кем мы работаем",
      whoWeWorkWithSubtitle: "Мы обслуживаем широкий круг клиентов в сфере логистики и торговли.",
      clientType1: "Транспортные компании",
      clientType2: "Экспедиторы",
      clientType3: "Экспортёры и импортёры",
      clientType4: "Логистические операторы",
      clientType5: "Таможенные брокеры",
      whereWeOperateTitle: "Где мы работаем",
      whereWeOperateIntro: "GeoGlobalGate LTD работает на всех активных пограничных пропускных пунктах Грузии и обслуживает международные маршруты через следующие страны:",
      whereWeOperateGeorgia: "Грузия — все активные таможенные переходы",
      whereWeOperateCountries: "Страны ЕС, Турция, Азербайджан, Армения, Россия, Казахстан, Китай и другие",
      whereWeOperateBorders: "Сарпи, Вале, Ларси, Красный Мост, Картсахи, Лагодехи и др.",
      coverageLabel: "Зона охвата",
      coverageItem1: "Грузия",
      coverageItem2: "Переходы: Сарпи, Вале, Ларси, Красный Мост, Картсахи, Лагодехи и др.",
      coverageItem3: "Транзит: ЕС, Турция, Азербайджан, Армения, Россия, Казахстан, Китай…",
      statsTitle: "GeoGlobalGate — в цифрах",
      statDeclarationsValue: "43 389+",
      statDeclarations: "Оформленных деклараций T1/T2",
      statCountriesValue: "37",
      statCountries: "Охваченных стран",
      statClientsValue: "1 570+",
      statClients: "Довольных клиентов",
      statSpeedValue: "10–20 мин",
      statSpeed: "Среднее время обработки",
      faq6Q: "Какие документы необходимы?",
      faq6A: "Для подготовки декларации T1 нам обычно требуются:",
      faq6Step1: "Коммерческий инвойс",
      faq6Step2: "Упаковочный лист",
      faq6Step3: "Транспортный документ (CMR)",
      faq6Step4: "Данные транспортного средства и водителя",
      faq6Step5: "Информация о маршруте",
      faq6Closing: "Если потребуются дополнительные документы, наша команда вас проинформирует.",
      faq7Q: "Ваш сервис доступен 24 часа в сутки?",
      faq7A: "Да, мы работаем в том числе в поздние часы, чтобы поддержка ваших грузоперевозок была обеспечена в любое время.",
      faq7A2: "Мы понимаем, что логистика — непрерывный процесс, поэтому наша команда готова помочь 24 часа в сутки — ночью, в выходные и праздничные дни.",
      careerBadge: "Мы нанимаем",
      careerTitle: "Начните карьеру в GeoGlobalGate",
      careerP1: "GeoGlobalGate LTD помогает компаниям эффективно управлять сложными таможенными и транзитными процедурами на международных рынках.",
      careerP2: "Мы растём — и всегда ищем мотивированных профессионалов, ориентированных на профессиональное развитие и долгосрочный карьерный рост.",
      careerP3: "Если у вас есть опыт в таможенном деле, логистике или международной торговле, или вы готовы к новым профессиональным вызовам — мы будем рады ознакомиться с вашим резюме.",
      careerP4: "Мы предлагаем динамичную и поддерживающую рабочую среду, где у вас будет возможность развивать профессиональные компетенции и участвовать в реальных международных транзитных операциях.",
      careerP5: "Мы также приветствуем кандидатов, планирующих начать карьеру в этой сфере — GeoGlobalGate может стать важным этапом вашего профессионального развития.",
      careerCta: "📩 Пожалуйста, свяжитесь с нами или отправьте ваше резюме на:",
      customerServiceSubtitle: "Ответы на ваши вопросы",
      customerServiceP1: "Мы помогаем вам быстро и эффективно получить нужную поддержку.",
      customerServiceP2: "Будь то транзит, таможенные процедуры или координация грузов — мы обеспечиваем направление каждого запроса к профильному специалисту.",
      customerServiceTagline: "Чёткая коммуникация. Быстрое решение.",
      footerFollowUs: "Follow Us",
      footerRights: "© 2026 GeoGlobalGate LTD — Все права защищены",
      navHowWeWork: "Как мы работаем",
      navCareer: "Карьера",
      navStats: "Цифры",
      successModalTitle: "Заявка принята",
      successModalCompany: "Компания \"GeoGlobalGate\" получила вашу заявку.",
      successModalMessage: "Наш менеджер свяжется с вами в ближайшее время.",
      successModalClose: "Закрыть",
      navFaq: "FAQ",
      faqTitle: "Часто задаваемые вопросы (FAQ)",
      faq1Q: "Кто предоставляет услуги NCTS T1 в Грузии?",
      faq1A: "GeoGlobalGate LTD — лицензированный оператор NCTS в Грузии, предлагающий полный спектр услуг по транзитным декларациям T1, таможенным процессам и управлению международными грузоперевозками.",
      faq2Q: "Для кого предназначены ваши услуги?",
      faq2A: "GeoGlobalGate LTD сотрудничает как с малым и средним бизнесом, так и с крупными компаниями, которые ищут надёжного и эффективного партнёра.",
      faq3Q: "Как начинается сотрудничество?",
      faq3A: "Сотрудничество начинается с детального анализа ваших потребностей, после чего мы предлагаем конкретное, адаптированное под вас решение.",
      faq3Step1: "Отправьте нам детали отправки",
      faq3Step2: "Мы подготовим вашу декларацию T1",
      faq3Step3: "Вы получите документы мгновенно",
      faq3Step4: "Грузовик отправляется без задержек",
      faq4Q: "Как быстро оказывается услуга?",
      faq4A: "Наша команда обеспечивает максимально быстрое и эффективное выполнение процессов при соблюдении высоких стандартов качества. Документ NCTS T1 оформляется в течение 10–20 минут после получения полного пакета документов.",
      faq5Q: "Как я могу с вами связаться?",
      faq5A: "Вы можете связаться с нами по контактным номерам, указанным на сайте, а также по электронной почте. Кроме того, заявку можно подать в электронном виде через наш портал.",
    },
  },
  tr: {
    translation: {
      navHome: "Ana Sayfa",
      navAbout: "Hakkımızda",
      navServices: "Hizmetler",
      navOffers: "Tarifeler",
      navContact: "İletişim",
      welcome: "Gürcistan'da NCTS T1 Transit Belgesi Hazırlanması",
      desc: "Gürcistan'da NCTS T1 beyannamesi hizmetleri sunuyor ve şirketlerin T1 transit belgelerini hızlı ve kolay şekilde düzenlemelerine yardımcı oluyoruz",
      contact: "Bize Ulaşın",
      aboutTitle: "GeoGlobalGate LTD Hakkında",
      aboutText: "GeoGlobalGate LTD, Gürcistan Maliye Bakanlığı Gelir Servisi tarafından lisanslanmış olup Gürcistan'da NCTS T1 belgesi hazırlama hizmeti sunan bir şirkettir. Amacımız gümrük prosedürlerini basitleştirmek ve şirketlerin zaman ile kaynaklarını optimize etmelerine yardımcı olmaktır.",
      aboutWhyTitle: "Şirketler neden GeoGlobalGate LTD'yi ortak olarak seçiyor?",
      aboutWhyText: "Bizimle çalışmak; güvenilirlik, profesyonellik ve sonuç odaklı bir yaklaşım anlamına gelir. Her müşteriye ihtiyaçlarına özel çözümler sunuyor ve sürecin verimli ve şeffaf biçimde yönetilmesini sağlıyoruz. Amacımız yalnızca hizmet sunmak değil — işletme büyümesini ve gelişimini gerçekten destekleyen uzun vadeli ortaklıklar kurmaktır. Ekibimiz, NCTS T1 belgelerini en kısa sürede hazırlamanıza yardımcı olmak için 7/24 hazır. Hizmetleri uzaktan ve elektronik ortamda sunuyoruz; bu da hızlı, basit ve etkili bir süreç sağlıyor.",
      aboutServicesTitle: "Hizmetlerimiz şunları kapsar:",
      aboutServiceItem1: "NCTS T1 transit beyannamelerinin hazırlanması.",
      aboutServiceItem2: "Gümrük belgelerinin tam olarak yönetilmesi.",
      aboutServiceItem3: "Gümrük makamlarıyla koordinasyon ve operasyonel destek.",
      aboutRepresentativeText: "Gümrük terminalinde güvenilir temsilciniz olarak hareket ediyor ve tüm prosedürlerin doğru ve zamanında yürütülmesini sağlıyoruz.",
      aboutBestChoiceTitle: "GeoGlobalGate LTD neden en iyi seçiminizdir?",
      aboutBestItem1: "Gürcistan'da Lisanslı NCTS Operatörü",
      aboutBestItem2: "7/24 Hizmet – Gecikme Yok",
      aboutBestItem3: "Uzaktan Hizmet – Fiziksel Varlık Gerekmez",
      aboutBestItem4: "Karmaşık Transit Taşımacılık Deneyimi",
      aboutCtaText: "Bugün bizimle iletişime geçin ve Gürcistan'da güvenilir gümrük hizmetleri alın.",
      servicesNavLabel: "Hizmetler",
      servicesTitle: "Hizmetlerimiz",
      servicesSubtitle: "İşletmeniz için kapsamlı gümrük ve transit çözümleri.",
      svc1Title: "Gürcistan'da NCTS T1 Beyanname Hizmetleri",
      svc1Item1: "Hızlı T1 belge hazırlama",
      svc1Item2: "Elektronik işlem",
      svc1Item3: "7/24 uzaktan destek",
      svc2Title: "Gümrük Müşavirliği",
      svc2Item1: "Eksiksiz beyanname yönetimi",
      svc2Item2: "T1/T2 belgelendirmesi",
      svc2Item3: "Risk azaltma",
      svc3Title: "Transit Destek",
      svc3Item1: "Gümrük idareleriyle koordinasyon",
      svc3Item2: "Sınırlarda gerçek zamanlı yardım",
      svc3Item3: "Sorun çözümü",
      svc4Title: "İletişim Desteği",
      svc4Desc: "Hattımız 7/24 hizmet vermekte olup Gürcüce, Türkçe, Azerbaycanca, Rusça, İngilizce, Ukraynaca ve İspanyolca dillerinde çok dilli destek sağlamakta ve her zaman net ve etkin iletişimi güvence altına almaktadır.",
      service1: "Gümrük İşlemleri",
      service2: "Ekspertiz",
      service3: "Bitki Sağlığı Sertifikası Alımı",
      service4: "Menşe Belgesi Alımı",
      service5: "Diğer Gümrük Belgelerinin Alımı",
      offersTitle: "Gümrük Müşavirlik Fiyatları",
      offerSubtitle: "NCTS T1 Hizmet Fiyatları",
      column1: "Ad",
      column2: "Gümrük Koridoru",
      column3: "Fiyat",
      table1: "Müşavirlik Hizmeti",
      table2: "Beyanname",
      table3: "Ek kod",
      table4: "Karmaşık beyanname (15'ten fazla ticari kod)",
      table5: "Bitki sağlığı sertifikası",
      table6: "Menşe sertifikası",
      table7: "Transit beyannamesi (T1)",
      green: "Yeşil",
      red: "Kırmızı",
      yellow: "Sarı",
      any: "Herhangi biri",
      warning: "* Fiyatlar tek bir gümrük beyannamesi başına belirlenmektedir; fiyata gümrük harçları ve diğer devlet vergileri dahil değildir.",
      input1: "Şirket Adı",
      input2: "Adınız",
      input3: "E-posta Adresiniz",
      phoneNumber: "Telefon Numaranız",
      vehicleNumber: "Araç Numarası",
      shipmentPrice: "Kargo Değeri",
      serviceTypeLabel: "Hangi hizmete ihtiyacınız var?",
      selectService: "Hizmet seçin",
      transit: "Transit",
      export: "İhracat",
      evaluationCustomsOffice: "Gürcistan'daki değerleme gümrük ofisi",
      exitCustomsOfficeExport: "Gürcistan'dan çıkış gümrük ofisi",
      entryCustomsOffice: "Gürcistan'a giriş gümrük ofisi",
      exitCustomsOfficeTransit: "Gürcistan'dan çıkış gümrük ofisi",
      route: "Güzergah",
      routeInfoTitle: "Güzergah Giriş Talimatları",
      routeInfoContent: "Lütfen güzergaha transit gümrük ofislerinin adlarını/kodlarını girin",
      routeInfoButton: "Anlaşıldı",
      finalClearanceLocation: "Nihai gümrükleme yeri",
      requiredDocuments: "Gerekli Belgeler",
      selectFile: "Dosya Seç",
      selectFiles: "Dosyaları Seç",
      attachFiles: "Dosya Ekle",
      cmr: "CMR",
      declaration: "transit beyannamesi",
      invoice: "Fatura",
      packingList: "Paketleme listesi",
      vehicleRegistration: "Araç ruhsatı",
      driverPassport: "Sürücü pasaportu",
      registrationCertificate: "Tescil belgesi veya D numaralı beyanname",
      input7: "Mesajınız",
      send: "Gönder",
      contactTitle: "Neye ihtiyacınız olduğunu bize söyleyin",
      status: "Talebiniz başarıyla gönderildi, şirket temsilcisi sizinle iletişime geçecektir.",
      error: "Mesaj gönderilemedi. Lütfen tekrar deneyin.",
      pleaseUpload: "Lütfen yükleyin",
      selectOption: "Lütfen seçin",
      paymentAmount: "Ödeme Tutarı",
      carNumber: "Araç Numarası",
      payButton: "Öde",
      negotiable: "bireysel",
      companyNameRequired: "Şirket adı zorunludur",
      nameRequired: "Ad zorunludur",
      emailRequired: "E-posta zorunludur",
      phoneRequired: "Telefon numarası zorunludur",
      carNumberRequired: "Araç numarası zorunludur",
      serviceRequired: "Hizmet türü zorunludur",
      invalidEmail: "Geçersiz e-posta formatı",
      evaluationCustomsRequired: "Değerleme gümrük ofisi zorunludur",
      exitCustomsExportRequired: "İhracat çıkış gümrük ofisi zorunludur",
      entryCustomsRequired: "Giriş gümrük ofisi zorunludur",
      exitCustomsTransitRequired: "Transit çıkış gümrük ofisi zorunludur",
      routeRequired: "Güzergah zorunludur",
      clearanceLocationRequired: "Nihai gümrükleme yeri zorunludur",
      filesRequired: "Dosyalar zorunludur",
      selectCurrency: "Para Birimi Seçin",
      uploaded: "Yüklendi",
      uploadedFiles: "Yüklenen Dosyalar",
      removeAll: "Tümünü Kaldır",
      removeFile: "Dosyayı Kaldır",
      files: "dosya",
      fileTooBig: "Dosya çok büyük",
      totalSizeExceeded: "Toplam boyut aşıldı",
      filesAddedSuccess: "dosya başarıyla eklendi",
      allFilesRemoved: "Tüm dosyalar kaldırıldı",
      acceptTerms: "Kabul ediyorum",
      termsAndConditions: "Şartlar ve Koşullar",
      termsRequired: "Şartlar ve koşulları kabul etmelisiniz",
      termsTitle: "Şartlar ve Koşullar",
      termsContent: `GeoGlobalGate – Şartlar ve Koşullar

I. Genel Hükümler
GeoGlobalGate şirketi, yürürlükteki mevzuata uygun olarak gümrük ve transit hizmetleri sunmaktadır.
Müşterinin şartları onaylaması, hukuken bağlayıcı bir sözleşme oluşturur.

II. Hizmetlerin Tam Açıklaması
Şirket aşağıdaki hizmetleri sunmaktadır:
• Kargo özellikleri, güzergahlar ve gümrük gereksinimleri hakkında danışmanlık;
• Tam gümrük belgeleri paketi hazırlama: fatura, paketleme listesi, taşıma belgeleri (CMR / Konşimento / Hava yük senedi), menşe sertifikası, ithalat-ihracat izinleri ve gümrük beyannameleri;
• Gümrük mevzuatına uyumun denetlenmesi ve gümrük yetkilileriyle iletişim;
• Vergi ve harçların hesaplanması;
• Risk yönetimi ve ticari ile gümrük ödemeleri konusunda danışmanlık;
• Transit prosedürlerin yönetimi, MRN takibi ve varış gümrüğünde kapatma.

III. Tam Hizmet Koşulları
• Müşteri, eksiksiz ve doğru belgeler sunmakla yükümlüdür. Şirket, hatalı veya eksik bilgiden kaynaklanan gecikmeler ya da cezalar için sorumluluk kabul etmez.
• Hizmetler, yalnızca tam belge paketi ve ödeme onayı alındıktan sonra başlar.
• Müşteri gereksinimleri karşılamazsa veya gerekli bilgileri sağlamazsa şirket hizmet reddetme hakkını saklı tutar.

IV. Hizmet Süreleri
• T1 beyannamesi, tam belge paketi ve ödeme onayı alındıktan sonra en fazla 1 saat içinde hazırlanır.
• Diğer hizmetlerin süreleri bireysel olarak belirlenir ve müşteriye önceden bildirilir.

V. İptal ve İade Politikası
İptal:
• T1 beyannamesi yalnızca gümrük işlemleri başlamadan önce iptal edilebilir.
• Kargo "serbest bırakıldıktan" sonra iptal mümkün değildir.
• İptal durumunda müşteri 100 GEL hizmet bedeli öder.

İade:
• Para iadesi yalnızca ödemenin yapıldığı hesaba veya karta yapılır.
• Para iadesi, talebin alınmasından itibaren en fazla 14 takvim günü içinde gerçekleştirilir.
• Tüm idari maliyetler müşteriye önceden bildirilir.

VI. Uyuşmazlık Çözüm Politikası
• Tüm şikayet ve uyuşmazlıklar e-posta yoluyla iletilmelidir: support@geoglobalgate.com.
• Şirket, müşterinin şikayetini en geç 10 iş günü içinde inceleyip yanıtlamakla yükümlüdür.
• Anlaşma sağlanamazsa uyuşmazlık, Gürcistan hukuku çerçevesinde Gürcistan mahkemelerinde çözülür.

VII. Veri Koruma
Müşterinin kişisel verileri yalnızca hizmet sunumu amacıyla ve yürürlükteki mevzuata uygun olarak işlenir.`,
      successModalTitle: "Başvuru Alındı",
      successModalCompany: "\"GeoGlobalGate\" şirketi başvurunuzu aldı.",
      successModalMessage: "Yöneticimiz en kısa sürede sizinle iletişime geçecektir.",
      successModalClose: "Kapat",
      navFaq: "FAQ",
      faqTitle: "Sıkça Sorulan Sorular (FAQ)",
      faq1Q: "Gürcistan'da NCTS T1 hizmetini kim sağlıyor?",
      faq1A: "GeoGlobalGate LTD, Gürcistan'da lisanslı bir NCTS operatörüdür; transit T1 beyannameleri, gümrük süreçleri ve uluslararası kargo yönetimi alanında tam hizmet sunmaktadır.",
      faq2Q: "Hizmetleriniz kimler için tasarlanmıştır?",
      faq2A: "GeoGlobalGate LTD, güvenilir ve etkili bir ortak arayan küçük ve orta ölçekli işletmelerle olduğu kadar büyük şirketlerle de çalışmaktadır.",
      faq3Q: "İşbirliği nasıl başlar?",
      faq3A: "İşbirliği, ihtiyaçlarınızın ayrıntılı analizi ile başlar; ardından size özel somut bir çözüm sunarız.",
      faq3Step1: "Bize gönderi detaylarını iletin",
      faq3Step2: "T1 beyannamenizi hazırlıyoruz",
      faq3Step3: "Belgeleri anında alırsınız",
      faq3Step4: "Araç gecikme olmadan yola çıkar",
      faq4Q: "Hizmet ne kadar hızlı sunulur?",
      faq4A: "Ekibimiz, yüksek kalite standartlarını korurken süreçlerin mümkün olan en hızlı ve verimli şekilde yürütülmesini sağlar. NCTS T1 belgesini, eksiksiz belgeleri aldıktan sonra 10–20 dakika içinde hazırlıyoruz.",
      faq5Q: "Sizinle nasıl iletişime geçebilirim?",
      faq5A: "Web sitesinde belirtilen iletişim numaraları ve e-posta yoluyla bize ulaşabilirsiniz. Ayrıca portalımız aracılığıyla başvurunuzu elektronik olarak gönderebilirsiniz.",
      nctsTitle: "NCTS Transit Sistemi",
      nctsIntro: "NCTS, Gürcistan dahil Avrupa ve ortak ülkelerdeki transit prosedürlerini kolaylaştıran ve hızlandıran birleşik bir dijital gümrük sistemidir.",
      nctsWhat: "NCTS Nedir?",
      nctsDescription: "NCTS kısaltması, Ortak Transit Sözleşmesi (CTC) kapsamında kurulan Yeni Bilgisayarlı Transit Sistemi'ni ifade eder. Bu sistem, tek bir transit beyannamesiyle aşağıdaki şekillerde mal hareketine olanak tanır:",
      nctsMovement1: "Bir CTC üyesi ülkeden başka bir CTC üyesi ülkeye",
      nctsMovement2: "Üçüncü bir ülkeden CTC üyesi bir ülkeye",
      nctsMovement3: "Bir CTC üyesi ülkeden üçüncü ülke üzerinden başka bir CTC üyesi ülkeye",
      nctsMovement4: "Bir CTC üyesi ülkeden üçüncü bir ülkeye",
      ctcCountriesTitle: "CTC Üyesi Ülkeler",
      ctcCountriesIntro: "CTC (Ortak Transit Sözleşmesi) şu ülkeleri kapsar:",
      ctcCountryEU: "Tüm AB Üyesi Devletler (Belçika, Bulgaristan, Çekya, Danimarka, Almanya, Estonya, İrlanda, Yunanistan, İspanya, Fransa vb.)",
      ctcCountrySwitzerland: "İsviçre",
      ctcCountryNorway: "Norveç",
      ctcCountryIceland: "İzlanda",
      ctcCountryMacedonia: "Kuzey Makedonya",
      ctcCountrySerbia: "Sırbistan",
      ctcCountryTurkey: "Türkiye",
      ctcCountryUK: "Birleşik Krallık",
      ctcCountryGeorgia: "Gürcistan",
      nctsImportanceTitle: "NCTS Neden Önemlidir?",
      nctsSimplification: "Gümrük süreçlerinin basitleştirilmesi",
      nctsSimplificationDesc: "Belgeler otomatik hale getirilmiştir; gümrük yetkilileri kargoyu gerçek zamanlı olarak izler, bu da formaliteleri azaltır ve gecikmeleri önler.",
      nctsControl: "Geliştirilmiş denetim",
      nctsControlDesc: "Kargo güzergahı tamamen takip edilebilir; herhangi bir sapma veya aksaklık sisteme anında kaydedilir.",
      nctsSpeed: "Hız ve şeffaflık",
      nctsSpeedDesc: "Transit prosedürleri daha hızlı ve bürokratik engeller minimum düzeydedir; bu da kayıp veya yasadışı sevkiyat riskini azaltır.",
      nctsEfficiency: "Uluslararası verimlilik",
      nctsEfficiencyDesc: "AB dışında ortak ülkeleri de kapsayan sistem, sınır ötesi işbirliğini önemli ölçüde geliştirmektedir.",
      t1BenefitsTitle: "T1 Avantajları",
      t1FormTitle: "T1 Formunun Önemi",
      t1FormDesc: "T1 formu, uluslararası transit için temel belgedir ve hem hukuki hem de operasyonel güvenceler sağlar:",
      t1Benefit1: "Malları hukuki açıdan güvence altına alır ve gümrük sistemine resmi olarak kaydeder",
      t1Benefit2: "Mallar nihai gümrük varış noktasına ulaşana kadar ithalat vergilerinin peşin ödenmesini erteler",
      t1Benefit3: "Hareketi kolaylaştırır ve gümrük prosedürlerinde harcanan zaman ile kaynakları azaltır",
      t1Benefit4: "Gümrük yetkilileri kargoyu kontrollü kabul ettiğinden lojistik süreci gereksiz gecikmelerden korur",
      t1PreparationTitle: "T1 Formu Nasıl Hazırlanır?",
      t1PreparationDesc: "Doğru doldurulmuş bir T1 formu için gerekli olanlar:",
      t1Requirement1: "Kargo hakkında doğru ve ayrıntılı bilgi",
      t1Requirement2: "Gönderici ve alıcıya ait eksiksiz veriler",
      t1Requirement3: "Güzergah bilgisi ve sınır geçiş ayrıntıları",
      t1Requirement4: "Özel gümrük sistemlerine erişim (örn. NCTS)",
      t1Recommendation: "Bu nedenle T1 formunun hazırlanmasını profesyonel bir gümrük müşaviri veya lojistik uzmanına bırakmanız önerilir.",
      nctsConclusion: "Sonuç",
      nctsConclusionText: "NCTS artık bir seçenek değil, zorunluluktur. Uygulanması daha hızlı, güvenli ve öngörülebilir bir transit sağlar. Uluslararası taşımacılık hizmetleri sunan şirketler için sisteme entegrasyon, küresel pazarda başarılı faaliyet göstermenin temel koşuludur.",
      heroCta: "NCTS T1 Beyannamenizi Dakikalar İçinde Hazırlayın!",
      aboutBestItem5: "Karmaşık Transit Davalarında Deneyim",
      aboutGuarantee: "GeoGlobalGate LTD, yetkili transit operatörü olarak tüm sevkiyatlara tam garanti kapsamı sağlamaktadır. Garanti kaydı ve muhasebesi, NCTS Transit Sistemi aracılığıyla tam uyum içinde yürütülmektedir.",
      howWeWorkTitle: "Nasıl Çalışıyoruz",
      howWeWorkSubtitle: "Basit ve şeffaf gümrükleme süreci",
      howWeWorkStep1Title: "Talep",
      howWeWorkStep1Desc: "Belgelerinizi ve kargo bilgilerinizi e-posta veya iletişim formu aracılığıyla bize gönderirsiniz. Yöneticimiz ayrıntıları onaylamak için sizinle iletişime geçer.",
      howWeWorkStep2Title: "Analiz",
      howWeWorkStep2Desc: "Belgelerinizi inceliyor, doğru transit prosedürünü belirliyor ve gümrükleme gerekliliklerini hesaplıyoruz.",
      howWeWorkStep3Title: "İşlem",
      howWeWorkStep3Desc: "Tüm belgeleri aldıktan sonra NCTS T1 beyannamesini 10–20 dakika içinde hazırlayıp sunuyoruz.",
      howWeWorkStep4Title: "Serbest Bırakma",
      howWeWorkStep4Desc: "Kargonuz gümrüklenerek serbest bırakılır. MRN'yi varış gümrüğünde tam kapanana kadar takip ediyoruz.",
      whoWeWorkWithTitle: "Kimlerle Çalışıyoruz",
      whoWeWorkWithSubtitle: "Lojistik ve ticaret sektöründeki geniş bir müşteri kitlesine hizmet veriyoruz.",
      clientType1: "Taşımacılık Şirketleri",
      clientType2: "Nakliyeciler",
      clientType3: "İhracatçılar ve İthalatçılar",
      clientType4: "Lojistik Operatörler",
      clientType5: "Gümrük Müşavirleri",
      whereWeOperateTitle: "Nerede Faaliyet Gösteriyoruz",
      whereWeOperateIntro: "GeoGlobalGate LTD, Gürcistan'daki tüm aktif sınır kapılarında faaliyet göstermekte ve aşağıdaki ülkeler üzerinden uluslararası güzergahlara hizmet vermektedir:",
      whereWeOperateGeorgia: "Gürcistan — Tüm Aktif Sınır Kapıları",
      whereWeOperateCountries: "AB Ülkeleri, Türkiye, Azerbaycan, Ermenistan, Rusya, Kazakistan, Çin ve daha fazlası",
      whereWeOperateBorders: "Sarpi, Vale, Larsi, Kırmızı Köprü, Kartsakhi, Lagodekhi vb.",
      coverageLabel: "Kapsama Alanı",
      coverageItem1: "Gürcistan",
      coverageItem2: "Sınır kapıları: Sarpi, Vale, Larsi, Kırmızı Köprü, Kartsakhi, Lagodekhi vb.",
      coverageItem3: "Transit: AB, Türkiye, Azerbaycan, Ermenistan, Rusya, Kazakistan, Çin…",
      statsTitle: "GeoGlobalGate — Rakamlarla",
      statDeclarationsValue: "43.389+",
      statDeclarations: "İşlenen T1/T2 Beyannamesi",
      statCountriesValue: "37",
      statCountries: "Kapsanan Ülke",
      statClientsValue: "1.570+",
      statClients: "Memnun Müşteri",
      statSpeedValue: "10–20 dk",
      statSpeed: "Ortalama İşlem Süresi",
      faq6Q: "Hangi belgeler gereklidir?",
      faq6A: "T1 beyannamesi hazırlamak için genellikle şunlara ihtiyaç duyarız:",
      faq6Step1: "Ticari fatura",
      faq6Step2: "Paket listesi",
      faq6Step3: "Taşıma belgesi (CMR)",
      faq6Step4: "Araç ve sürücü bilgileri",
      faq6Step5: "Güzergah bilgisi",
      faq6Closing: "Ek bilgi gerekirse ekibimiz sizi yönlendirecektir.",
      faq7Q: "Hizmetiniz 24 saat erişilebilir mi?",
      faq7A: "Evet, sevkiyatlarınıza her zaman destek sağlamak için geç saatlerde de çalışıyoruz.",
      faq7A2: "Lojistiğin kesintisiz bir süreç olduğunun farkındayız; bu nedenle ekibimiz 24 saat boyunca — geceleri, hafta sonları ve tatillerde de — yardıma hazırdır.",
      careerBadge: "İşe Alıyoruz",
      careerTitle: "GeoGlobalGate ile Kariyerinizi İnşa Edin",
      careerP1: "GeoGlobalGate LTD, uluslararası pazarlarda karmaşık gümrük ve transit prosedürlerini yönetmede şirketlere destek olur.",
      careerP2: "Büyüyoruz — ve bizimle büyümek isteyen, mesleki gelişim ve uzun vadeli kariyer odaklı motivasyonlu profesyoneller arıyoruz.",
      careerP3: "Gümrük, lojistik veya uluslararası ticaret alanında deneyiminiz varsa ya da yeni mesleki zorluklara hazırsanız, özgeçmişinizi incelemekten memnuniyet duyarız.",
      careerP4: "Mesleki yetkinliklerinizi geliştirebileceğiniz ve gerçek uluslararası transit operasyonlara katılabileceğiniz dinamik ve destekleyici bir çalışma ortamı sunuyoruz.",
      careerP5: "Bu alanda kariyerine başlamayı planlayan adayları da memnuniyetle karşılıyoruz — GeoGlobalGate, profesyonel gelişiminizde önemli bir adım olabilir.",
      careerCta: "📩 Lütfen bizimle iletişime geçin veya CV'nizi şu adrese gönderin:",
      customerServiceSubtitle: "Sorularınıza yanıtlar",
      customerServiceP1: "Doğru desteğe hızlı ve verimli şekilde ulaşmanıza yardımcı oluyoruz.",
      customerServiceP2: "İster transit, ister gümrük prosedürleri, ister sevkiyat koordinasyonu olsun — ekibimiz talebinizin ilgili uzmana yönlendirilmesini sağlar.",
      customerServiceTagline: "Net iletişim. Hızlı çözüm.",
      footerFollowUs: "Follow Us",
      footerRights: "© 2026 GeoGlobalGate LTD — Tüm Hakları Saklıdır",
      navHowWeWork: "Nasıl Çalışıyoruz",
      navCareer: "Kariyer",
      navStats: "Rakamlar"
    },
  },
};

// Get initial language from localStorage or default to Georgian
const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('selectedLanguage');
  return savedLanguage || 'ge';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(), // Initialize with saved language from localStorage
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;